<template>
    <div v-if="site" class="v-flex" style="width: calc(100% + 10px)" :key = "refreshAll">
        <d-image-folder-create
            v-model  = "showCreate"
            :site    = "site"
            @created = "onFolderCreated"
        />
        <d-image-upload
            v-model      = "showUpload"
            :site        = "site"
            :folder      = "folder"
            :folder-label = "folder ? folderLabel(folder) : ''"
            @uploaded    = "loadImages"
        />
        <div v-if="loading" class="img-loading">
            <v-progress-circular indeterminate color="primary" size="48" />
        </div>
        <!--
        <div
            v-if="!site.imageroot"
            style="width: 500px; margin-left: calc(50% - 250px); margin-top: 90px; height: 250px;"
        >
            <v-card style="height: 245px;">
                <v-card-title>{{ $t('img.info.imageroot.title') }}</v-card-title>
                <v-card-text> {{ $t('img.info.imageroot.text')  }}</v-card-text>
            </v-card>
        </div>

        <div
            style="width: 500px; margin-left: calc(50% - 250px); margin-top: 90px; height: 400px"
            v-if="site.imageroot && !schedule && folders && folders.length === 0"
        >
            <v-card>
                <v-card-title>{{ $t('img.confirm.initialize.title') }}</v-card-title>
                <v-card-text v-html="$t('img.confirm.initialize.text')"></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        @click="onInitialize"
                        color="primary"
                    >
                        Einplanen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
        -->

        <div
            style="width: 500px; margin-left: calc(50% - 250px); margin-top: 90px"
            v-if="folders && folders.length === 0 && !(site.imageroot && schedule)"
        >
            <v-card>
                <v-card-text>{{ $t('img.folder.create.empty') }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="showCreate = true">
                        {{ $t('img.folder.create.action') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>

        <div
            style="width: 500px; margin-left: calc(50% - 250px); margin-top: 90px; height: 400px"
            v-if="site.imageroot && schedule && folders && folders.length === 0"
        >
            <v-card>
                <v-card-title>{{ $t('img.confirm.scheduled.title') }}</v-card-title>
                <v-card-text v-html="$t('img.confirm.scheduled.text')"></v-card-text>
            </v-card>
        </div>

        <div class="w-100 v-flex h-100" v-if="folders && folders.length > 0">
            <v-btn
                v-show="folders && folders.length > 0 && isPrivileged"
                color="primary"
                small
                absolute
                bottom
                left
                fab
                style="bottom: 10px"
                @click = "onReset"
            >
                <v-icon>mdi-image-remove</v-icon>
            </v-btn>

            <div class="d-flex flex-column align-self-start" style="width: 400px; min-width: 300px;">
            <v-tabs
                :key    = "tabsKey"
                show-arrows
                v-model = "folderIndex"
                class   = "ma-0 pa-0 mt-2 folder-tabs"
                @change = "onFolder"
                vertical
                style="width: 100%;"
            >
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab
                    v-for        = "(folder,index)  in folders"
                    :key         = "index"
                    active-class = "folder-tab-active primary"
                    class        = "folder-tab"
                >
                    <div v-if="!folder.date">
                        <div class="folder-date">
                            {{ $t( 'image.category.common' )}}
                        </div>
                        <div class="folder-name">
                            {{ folderLabel (folder) }}
                        </div>
                    </div>
                    <div v-if="folder.date">
                        <div class="folder-date">
                            {{ formatDate (folder.date) }}
                        </div>
                        <div class="folder-name">
                            {{ folderLabel (folder) }}
                        </div>
                    </div>
                </v-tab>
            </v-tabs>
            <div class="mt-2">
                <v-btn text small color="primary" @click="showCreate = true">
                    <v-icon left small>mdi-folder-plus</v-icon>
                    {{ $t('img.folder.create.action') }}
                </v-btn>
            </div>
            </div>
            <v-container class="img-panel mt-2">
                <div style="height: 740px; overflow-y: scroll; padding-right: 1px; width: 100%;" v-if="folder" :key="refresh" >
                    <div class="image-overlay" v-if="carousel"></div>

                    <div class="folder-actions">
                        <v-btn v-if="!folder.archive" text small color="primary" @click="showUpload = true">
                            <v-icon left small>mdi-upload</v-icon>
                            {{ $t('img.upload.action') }}
                        </v-btn>
                        <v-btn
                            text small color="primary"
                            :loading  = "downloading"
                            :disabled = "!images || images.length === 0"
                            @click    = "onDownloadFolder"
                        >
                            <v-icon left small>mdi-download</v-icon>
                            {{ $t('img.download.action') }}
                        </v-btn>
                        <span class="folder-empty" v-if="images && images.length === 0">
                            {{ $t('img.folder.create.noimages') }}
                        </span>
                    </div>

                    <div class="image-zoom" v-if="carousel" style="max-width: 62%; margin-left: 8%">
                        <div style="position: absolute; right: 25px; top: 22px; z-index: 999; width: 25px">
                            <v-btn fab color="primary" @click="onClose" small >
                                <v-icon >mdi-close</v-icon>
                            </v-btn>

                            <v-btn fab color="primary" @click="onMax" small class="mt-3" >
                                <v-icon >mdi-arrow-expand-all</v-icon>
                            </v-btn>

                            <v-btn fab color="primary" @click="onDownloadImage" small class="mt-3" >
                                <v-icon >mdi-download</v-icon>
                            </v-btn>
                        </div>
                        <v-carousel
                            hide-delimiters
                            show-arrows-on-hover
                            height="750"
                            class="mt-5"
                            v-model="position"
                        >
                            <v-carousel-item
                                v-for="(image,i) in images"
                                :key="i"
                            >
                                <img-image
                                    :id="image.id" :item="image" :image="true"
                                />
                            </v-carousel-item>
                        </v-carousel>
                    </div>

                    <v-row style=" margin-left: -2px; margin-top: -2px;">
                        <v-col
                            v-for="(image, index) in images"
                            :key="index"
                            class="d-flex child-flex image-col"
                            :cols="cols"
                        >
                            <div>
                                <a @click="onSelect(index)">
                                    <img-image :id="image.id" :item="image" />
                                </a>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>

import Img from "@/modules/img/components/service/Img";
import ImgImage from "@/modules/img/components/main/ImgImage";
import { ARCHIVE_SUFFIX } from "@/modules/img/components/service/Folders";
import Core from "@/modules/core/service/Core";
import FolderDownload from "@/modules/img/components/service/FolderDownload";
import DImageFolderCreate from "@/modules/img/components/DImageFolderCreate.vue";
import DImageUpload from "@/modules/img/components/DImageUpload.vue";

export default {
    name: "ImgSiteImages",

    components: {
        DImageFolderCreate,
        DImageUpload,
        ImgImage,
    },

    props: {
        site: {

        }
    },

    data: () => ({
        folder: null,
        schedule: null,
        images: null,
        refresh: 0,
        refreshAll: 0,
        carousel: false,
        position: 0,
        folders: null,
        folderIndex: 0,
        confirm: false,
        downloading: false,
        loading: true,
        showCreate: false,
        showUpload: false,
        tabsKey: 0,
    }),

    watch: {
        unitId () {
            this.loadFolders(this.site.id);
        }
    },

    mounted() {
        this.loadFolders(this.site.id);
    },

    computed: {
        unitId () {
            if (!this.site) {
                return null;
            }

            return this.site.id;
        },

        imageRoot () {
            return this.site ? this.site. imageroot : null;
        },

        cols () {
            const preferences = this.$store.getters.preferences;
            return preferences.smallimages ? 1 : 2;
        },

        isPrivileged () {
            return Core.role.privileged();
        }
    },

    methods: {
        onReset () {
            Core.message.confirm(
                this,
                this.$t("img.confirm.reset.title"),
                this.$t("img.confirm.reset.text"),
                Core.message.Default,
                (value) => {
                    if (value) {
                        Img.reset(this.site.id).then(() => {
                            this.images = null;
                            this.folders = [];
                            this.folder = null;
                            this.schedule = null;
                            this.refreshAll ++;
                        });
                    }
                })
        },

        onFolder () {
            this.carousel = false;
            this.folder = this.folders[this.folderIndex];
            this.loadImages();
        },

        onSelect (index) {
            this.carousel = true
            this.position = index;
        },

        onRefresh () {
            this.loadFolders(this.site.id);
            this.loadImages();
            this.folderIndex = 0;
        },

        // Select the new folder (a media service one, not an archive folder of the same name)
        onFolderCreated (created) {
            this.showCreate = false;
            Img.load(this.site.id).then(data => {
                this.folders = data.folders;
                this.schedule = data.schedule;
                const index = this.folders.findIndex(folder => !folder.archive && folder.name === created.name);
                this.folderIndex = Math.max(index, 0);
                this.folder = this.folders[this.folderIndex];
                this.confirm = false;
                // rebuild the tabs, they don't pick up a changed list reliably
                this.tabsKey++;
                this.loadImages();
            });
        },

        onDownloadFolder () {
            const folder = this.folder;
            const name = this.folderLabel(folder);
            this.downloading = true;
            FolderDownload.zip(this.site.id, folder, name, this.images || [], false).then(url => {
                if (url) {
                    FolderDownload.save(url, (this.site.fabricNo || this.site.id) + " " + name + ".zip");
                    Core.message.hint(this, this.$t("img.download.done"));
                }
            }).catch(() => {
                Core.message.hint(this, this.$t("img.download.failed"));
            }).finally(() => {
                this.downloading = false;
            });
        },

        onDownloadImage () {
            FolderDownload.image(this.images[this.position]).catch(() => {
                Core.message.hint(this, this.$t("img.download.failed"));
            });
        },

        onMax () {
            Img.fullscreen(this, this.images[this.position])
        },

        onClose () {
            this.carousel = false;
        },

        onCancel () {
            this.confirm = false;
        },

        onInitialize () {
            Img.sync(this.site.id).then ((data) => {
                this.schedule = data;
            }).catch((error) => {
                Core.message.popup(this, error.id, error.parameter);
            });
        },

        loadFolders (siteId) {
            this.loading = true;
            Img.load(siteId).then((data) => {
                this.folders = data.folders;
                this.schedule = data.schedule;
                if (!this.folders || this.folders.length === 0) {
                    this.confirm = true;
                } else {
                    this.folder = this.folders[0];
                    this.loadImages()
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        loadImages () {
            return Img.images(this.site.id, this.folder)
                .then(data => {
                    this.images = data;
                    this.refresh++;
                })
                .catch(() => {
                    this.images = [];
                    this.refresh++;
                })

        },

        folderLabel (folder) {
            // categories like "image.cat.site" are translated, names users gave a folder are not
            const name = this.$te(folder.name) ? this.$t(folder.name) : folder.name;
            return name + (folder.archive ? ARCHIVE_SUFFIX : "");
        },

        formatDate (value) {
            return Core.format.date.display(value);
        }
    }
}
</script>

<style scoped>

.img-loading {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
}

.img-panel {
    display: flex;
    padding: 0;
    min-width: calc(100% - 300px);
}

.image-col {
    padding: 2px;
}

.image-zoom, .image-overlay {
    position: absolute;
    height: 740px;
    width: calc(100% - 70px);
    z-index: 10;
}

.image-overlay {
    z-index: 2;
    width: calc(100% - 70px);
    opacity: 0.75;
    background-color: white;
}

.folder-tab {
    text-transform: unset;
    letter-spacing: unset;
    font-size: 15px;
    color: black!important;
    font-weight: normal;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-right: 5px;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    width: calc(100% - 5px);
    margin-bottom: 2px;
    height: 44px!important;
}

.folder-tabs {
    /* as high as the folders, so the button for a new folder follows right after the last one */
    flex: 0 0 auto;
    height: auto;
    padding-right: 75px;
    margin-bottom: 4px;
    border-bottom-style: none;
    border-bottom-width: 1px;
    margin-right: 75px;
    border-bottom-color: lightgray;
    width: calc(100% - 10px);
}

.folder-actions {
    display: flex;
    align-items: center;
    padding: 2px 0 6px;
}

.folder-empty {
    margin-left: 12px;
    font-size: 14px;
    color: gray;
}

.folder-date {

}

.folder-name {
    font-size: 12px;
    margin-top: 2px;
}

.folder-tab-active {
    color: white!important;
}

::v-deep .theme--light.v-tabs>.v-tabs-bar {
    border-bottom-style: none!important;
}

div::-webkit-scrollbar {
    width: 8px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3)!important;
    border-radius: 8px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 8px;
}

::v-deep .v-tabs-slider {
    display: none;
}

</style>
